import React, {useState, useEffect, memo, useCallback, useRef} from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import NavSelect from './nav_select'

const Nav = () => {
    const domain = useSelector(state => state.initial.domain)
    const categoryData = useSelector(state => state.category.categoryData)
    const currentCategory = useSelector(state => state.category.currentCategory)
    const { cate, reduce } = currentCategory
    const [selectCate, setSelectCate] = useState(null)
    const [activeLayer, setActiveLayer] = useState(null)
    const timerRef = useRef(null);
    const [prevData, setPrevData] = useState(null)

    const inchentIndex = useCallback((data, cate) => {
        const selectIndex = data.findIndex(v => v.cate_id === cate)
        return selectIndex
    },[])

    const setFdiv0List = useCallback(() => {
        const cateData = [...categoryData]
        const findIndex = cateData.findIndex(v => v.cate_id === '0000000102') // 컴퓨터·노트북·모바일
        const depth1 = cateData[findIndex].child
        const fdiv0List = depth1.filter(v => v.f_div === 0)

        cateData[findIndex] = {
            ...cateData[findIndex],
            child: fdiv0List
        }
        return cateData
    },[categoryData])

    const setData = useCallback(() => {
        const cateData = [...categoryData]
        const cateObj = {}
        cateObj.cate0 = domain === 'shopping' ? cateData : setFdiv0List()
        cateObj.cate0SelectIndex = domain === 'shopping'
            ? inchentIndex(cateData, cate[0].cate_id)
            : cateData.findIndex(v => v.cate_id === '0000000102') // pc견적에서는 대메뉴 컴퓨터 노트북 모바일로

        Object.keys(reduce).forEach((v, i) => {
            if (i !== 0 && (cateObj['cate'+i+'SelectIndex'] === undefined || cateObj['cate'+i+'SelectIndex'] < 0)) {
                return false
            }
            cateObj['cate'+(i+1)] = cateObj['cate' + i][cateObj['cate'+ i +'SelectIndex']].child
            cateObj['cate'+(i+1)+'SelectIndex'] = inchentIndex(cateObj['cate'+(i+1)], reduce[v])
        })
        setSelectCate(cateObj)
    },[categoryData, cate, reduce, inchentIndex, domain, setFdiv0List])


    const depAction = (flag) => {
        if(!flag){
            timerRef.current = setTimeout(()=>{
                depReset()
            },2000)
        }else{
            clearTimeout(timerRef.current)
        }
    }
    const depReset = (flag) => {
        if(flag){
            if(prevData){
                setSelectCate(prevData)
            }else{
                setSelectCate(selectCate)
            }
            setPrevData(null)
        }else{
            setSelectCate(selectCate)
        }
        setActiveLayer(null);
    }


    const clickSetData = useCallback((dep, index) => {
        const originData = {...selectCate}
        const timeRollbackFn =(val,index)=>{
            if(originData[val][index].f_clk === 0){
                setPrevData(selectCate)
                depAction('')
            }
        }

        timeRollbackFn(`cate${dep}`, index)
        if (dep === 0) {
            setSelectCate({
                cate0: originData.cate0,
                cate0SelectIndex: index,
                cate1: originData.cate0[index].child,
            })
        } else if (dep === 1) {
            setSelectCate(state => ({
                ...state,
                cate1SelectIndex: index,
                cate2: originData.cate1[index].child,
                cate2SelectIndex: -1,
                cate3: undefined,
                cate3SelectIndex: undefined,
                cate4: undefined,
                cate4SelectIndex: undefined,
            }))
        } else if (dep === 2) {
            setSelectCate(state => ({
                ...state,
                cate2SelectIndex: index,
                cate3: originData.cate2[index].child,
                cate3SelectIndex: -1,
                cate4: undefined,
                cate4SelectIndex: undefined,
            }))
        } else if (dep === 3) {
            setSelectCate(state => ({
                ...state,
                cate3SelectIndex: index,
                cate4: originData.cate3[index].child,
                cate4SelectIndex: undefined,
            }))
        }
    },[selectCate, setSelectCate])

    const onClickMenu = useCallback((dep, index) => () => {
        clickSetData(dep, index)
        setActiveLayer(dep+1)
    }, [clickSetData, setActiveLayer])

    useEffect(() => {
        if (cate.length > 0) {
            setData()
        }
    }, [reduce, cate, setData])

    return (
        <Style>
            {selectCate && (
                <ul className="nav_ul">
                    <li>
                        <span className="txt">홈</span>
                    </li>
                    {domain === 'shopping' && (
                        <NavSelect prevData={prevData} depReset={depReset} depAction={depAction} data={selectCate.cate0} dep={0} activeLayer={activeLayer} setActiveLayer={setActiveLayer} demenu={true} selector={selectCate.cate0SelectIndex} onClickMenu={onClickMenu} setData={setData} />
                    )}
                    {selectCate?.cate1?.length > 0 && (
                        <NavSelect prevData={prevData} depReset={depReset} depAction={depAction} data={selectCate.cate1} dep={1} activeLayer={activeLayer} setActiveLayer={setActiveLayer} selector={selectCate.cate1SelectIndex} onClickMenu={onClickMenu} setData={setData} />
                    )}
                    {selectCate?.cate2?.length > 0 && (
                        <NavSelect prevData={prevData} depReset={depReset} depAction={depAction} data={selectCate.cate2} dep={2} activeLayer={activeLayer} setActiveLayer={setActiveLayer} selector={selectCate.cate2SelectIndex} onClickMenu={onClickMenu} setData={setData} />
                    )}
                    {selectCate?.cate3?.length > 0 && (
                        <NavSelect prevData={prevData} depReset={depReset} depAction={depAction} data={selectCate.cate3} dep={3} activeLayer={activeLayer} setActiveLayer={setActiveLayer} selector={selectCate.cate3SelectIndex} onClickMenu={onClickMenu} setData={setData} />
                    )}
                    {selectCate?.cate4?.length > 0 && (
                        <NavSelect prevData={prevData} depReset={depReset} depAction={depAction} data={selectCate.cate4} dep={4} activeLayer={activeLayer} setActiveLayer={setActiveLayer} selector={selectCate.cate4SelectIndex} onClickMenu={onClickMenu} setData={setData} />
                    )}
                </ul>
            )}
        </Style>
    )
}

const Style = styled.div`
    position: relative;
    margin: 8px 0 0;
    z-index: 10;

    .nav_ul {
        display: flex;

        & > li {
            position: relative;

            & + li:before {
                font-family: 'ppingkr_v4';
                content: '\\e906';
                color: #999;
            }
            a, button {
                &:hover {
                    color: #418ded
                }
            }
            &.active {
                .nav_layer {
                    display: block
                }
                .arrow {
                    &:after {
                        color: #418ded;
                        transform: rotate(180deg);
                        border-color: #418ded
                    }
                }
            }
        }
    }
    .txt {
        color: #333;
        padding: 0 8px 5px;
        white-space: nowrap;

        &.arrow {
            cursor: pointer;

            &:after {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                margin: 0 0 0 5px;
                width: 18px;
                height: 18px;
                border: 1px solid #ccc;
                font-family: 'ppingkr_v4';
                content: '\\e904';
                box-sizing: border-box;
            }
        }
    }
    .nav_layer {
        position: absolute;
        top: 20px;
        left: 10px;
        border: 1px solid #333;
        background: #fff;
        padding: 5px 9px;
        white-space: nowrap;

        li {
            a, button {
                color: #333;
                line-height: 20px;
            }
            &.active {
                a, button {
                    color: #418ded;
                    font-weight: 700;
                }
            }
        }
    }
`

export default memo(Nav)



// WEBPACK FOOTER //
// ./src/estimate_list/components/nav/index.js